<template>
  <!--@click.stop prevents the click event from occurring on the row -->
  <b-dropdown :id="'ddl-choose-'+group.uugid"
              variant="primary" class="mx-1" left text="Choose"
              @click.stop=""
              @show="showOptions = true"
              @hide="showOptions = false">
    <!-- Conditionally add/remove dropdown items from the DOM. This helps improve rendering speed and repainting -->
    <template v-if="showOptions">
      <b-dropdown-item
        :id="'lnk-edit-grp-'+group.uugid"
        :to="{ name: 'GroupDashboard', params: {id: group.uugid, selectedComponent:'appEditGroup' }}"
        v-if="group._isAdmin">
        Edit Group
      </b-dropdown-item>
      <b-dropdown-item
        :id="'lnk-add-mem-'+group.uugid"
        :to="{ name: 'GroupDashboard', params: {id: group.uugid, selectedComponent:'appAddMembers' }}">
        Add Members
      </b-dropdown-item>
      <b-dropdown-item
        :id="'lnk-edit-mem-'+group.uugid"
        :to="{ name: 'GroupDashboard', params: {id: group.uugid, selectedComponent:'appEditMembers' }}">
        Edit Members
      </b-dropdown-item>
      <b-dropdown-item
        v-if="group._isAdmin"
        v-b-modal.group-expiration-modal
        :id="'lnk-renew-'+group.uugid"
        :disabled="submittingGroupRenew"
        @click="renewOptionSelected">
        Renew
      </b-dropdown-item>
      <b-dropdown-item
        v-if="group._isAdmin"
        v-b-modal.groups-main-delete-group-confirm
        :id="'lnk-delete-'+group.uugid"
        :disabled="submittingGroupDelete"
        @click="deleteOptionSelected"
      >
        Delete
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>
<script>
export default {
  name: 'GroupListActions',
  props: {
    group: {
      type: Object,
      required: true,
    },
    submittingGroupRenew: {
      type: Boolean,
      required: true,
      default: false,
    },
    submittingGroupDelete: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showOptions: false,
    };
  },
  methods: {
    deleteOptionSelected() {
      this.$emit('deleteOptionSelected', this.group.uugid);
    },
    renewOptionSelected() {
      this.$emit('renewOptionSelected', this.group);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/GroupListActions.vue